const EXTENSION_SETTINGS_BASE_KEY = "extension-settings";

export const extensionSettingsQueryKeys = {
    settings() {
        return [EXTENSION_SETTINGS_BASE_KEY, "defaults"] as const;
    },
    governanceUsers() {
        return [EXTENSION_SETTINGS_BASE_KEY, "governance-users"] as const;
    },
    extensionVersion() {
        return [EXTENSION_SETTINGS_BASE_KEY, "extension-version"] as const;
    },
};
